import { Component, Inject, inject, Optional } from '@angular/core';
import { VerifyFcComponent } from './verify-fc/verify-fc.component';
import { DikshitDetailsComponent } from './dikshit-details/dikshit-details.component';
import { DikshitAddressComponent } from './dikshit-address/dikshit-address.component';
import { CommentsComponent } from './comments/comments.component';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../common-component/loader/loader.component';
import { UpdateMemberService } from '../../services/raintree/Transmission/update-member.service';
import { ToastrService } from 'ngx-toastr';
import { VisitTransmissionService } from '../../services/raintree/Transmission/visit-transmission.service';
import { LocationService } from '../../services/common/location.service';
import { VisitHistoryComponent } from './visit-history/visit-history.component';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface Data{
  memKey:any,
  data:any,
  type:'Add details'|'Visit history'
}

@Component({
  selector: 'app-visited',
  standalone: true,
  imports: [
    LoaderComponent,
    CommonModule,
    VerifyFcComponent,
    // DikshitDetailsComponent,
    // DikshitAddressComponent,
    CommentsComponent,
    VisitHistoryComponent
  ],
  templateUrl: './visit.component.html',
  styleUrl: './visit.component.scss'
})

export class VisitComponent {

  memName='';
  activeView:'Add details'|'Visit history'='Add details';
  steps=['Family code','Comments'];//'Dikshyarthi\'s details','Address details',
  stepSl:number=0;
  allowedSteps:number[]=[0];
  loading=false;

  //data from/for verify-fc component
  dpName:string='';
  fcMembers:any[]=[];
  selectedMemKey:string|null=null;
  isMobile=false;
  data!:Data;
  
  //data from/for dikshit-details component
  memDetails={
    memFname:'', memMname:'', memLname:'',
    guardFname:'', guardMname:'', guardLname:'',
    familyCode:'',ritwik:{fullName:'',ritwikCode:'',state:'',district:'',workerType:''},
    memStatus:{label:'',value:-1},memReason:{label:'',value:-1},
    contact:'',email:''
  }
  dpRitwikName='';

  //data from/for dikshit-address component
  permAddress={
    address:'',
    landmark:'',
    pincode:null,
    state:'',
    stateList:[''],
    district:'',
    districtList:[''],
    postOffice:'',
    POList:['']
  };
  presAddress={
    smChk:false,
    address:'',
    landmark:'',
    pincode:null,
    state:'',
    stateList:[''],
    district:'',
    districtList:[''],
    postOffice:'',
    POList:['']
  };

  //data from/for comments component<any>undefined
  visit={
    selectedFeedbacks:[{feedbackCd:-1,feedbackMsg:''}],feedbackList:[{feedbackCd:-1,feedbackMsg:''}],
    selectedWorkers:[{ritwikCode:'',fullName:'',state:'',district:'',workerType:''}],
    comment:''
  };
  visited=false;
  visitAddress={
    address:'',
    landmark:'',
    pincode:null,
    state:'',
    stateList:[''],
    district:'',
    districtList:[''],
    // postOffice:'',
    // POList:['']
  };

  //data for visit history component
  visitHistoryDetails={
    visits:<any>[],
    errorPresent:false,
    errorMessage:'',
    emptyMessage:'',
    contactAccessor:{
      memKey: '',
      uiDistrict: '',
      uiState: ''
    }
  }
  
  canAccessVisitContact: boolean = false;
  flow:string='';
  constructor(
    @Optional() @Inject(MatBottomSheetRef<VisitComponent>) private sheetRef:MatBottomSheetRef<VisitComponent>,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData:Data,
    @Optional() @Inject(MatDialogRef<VisitComponent>) public dialogRef:MatDialogRef<VisitComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData:Data,
    public commonUtil:CommonUtilService,
    private updateMemberService:UpdateMemberService,
    public toasterService:ToastrService,
    private visitTransmission:VisitTransmissionService,
    private locationService:LocationService
  ){

    this.isMobile=this.commonUtil.isMobileDevice();
    this.data=sheetData||dialogData;
  }



  ngOnInit(){  
    
    this.canAccessVisitContact = this.data.data.canAcceesVisitContact
    console.log(this.data.data.canAccessVisitContact);
    
    this.getVisits();
    
    this.dpName=this.data.memKey.dikshyarthi_name;
    this.memName=this.optimizeName(this.data.memKey.dikshyarthi_name);
    let memParts=this.memName.trim().split(' ');
    this.memDetails.memFname=memParts[0]; this.memDetails.memMname=(memParts.length<3)?'':memParts[1];
    this.memDetails.memLname=(memParts.length<3)?memParts[1]:memParts.slice(2).join(' ');

    let fullName=this.memDetails.memFname+' '+this.memDetails.memMname+' '+this.memDetails.memLname;
    // console.log(fullName);
    

    let guardParts=this.optimizeName(this.data.memKey.guardian_name).trim().split(' ');
    this.memDetails.guardFname=guardParts[0]; this.memDetails.guardMname=(guardParts.length<3)?'':guardParts[1];
    this.memDetails.guardLname=(guardParts.length<3)?guardParts[1]:guardParts.slice(2).join(' ');
    
    this.dpRitwikName=this.data.memKey.ritwiki_name;
    
    this.permAddress.pincode=(this.data.memKey.pin!=='Unknown')?this.data.memKey.pin:'';
    this.permAddress.address=this.data.memKey.permanent_address;

    this.activeView=this.data.type;

    this.visitHistoryDetails.contactAccessor.memKey=this.data.memKey.SL_NO;
    this.visitHistoryDetails.contactAccessor.uiDistrict=this.data.memKey.district_name;
    this.visitHistoryDetails.contactAccessor.uiState=this.data.memKey.state_name;
    // this.getCategories();
  }

  getVisits(){
    this.loading=true;

    let payLoad={
      uiState:this.data.memKey.state_name,
      uiDistrict:this.data.memKey.district_name,
      memKey:this.data.memKey.SL_NO
    }
    // console.log(payLoad);
    
    this.visitTransmission.fetchVisitHistory(payLoad).subscribe({
      next:(response)=>{
        // console.log('fetchvisithistory response',response);
        if(response.error){
          this.visitHistoryDetails.errorMessage=response.message;
          this.visitHistoryDetails.errorPresent=true;
          this.getCategories();
        }
        else{
          this.visitHistoryDetails.visits=response.data;
          this.visitHistoryDetails.emptyMessage=response.message;
          // console.log('visithistorydetails in visit component before name optimization',this.visitHistoryDetails);
          this.visitHistoryDetails.visits.forEach((visit:any) => {
            visit.visitedBy = this.optimizeName(visit.visitedBy);
            if(visit.accomp_wrk_dtl){
              visit.accomp_wrk_dtl.forEach((wrkr: any) => {
                wrkr.accompWrkName = this.optimizeName(wrkr.accompWrkName);
                wrkr.accompWrkDistrict = this.optimizeName(wrkr.accompWrkDistrict);
                wrkr.accompWrkState = this.optimizeName(wrkr.accompWrkState);
              });
            }
          });
          // console.log('visithistorydetails in visit component after name optimization',this.visitHistoryDetails);
          
          this.isVisited();
        }
      },
      error:(err)=>{
        this.visitHistoryDetails.errorMessage=err;
        this.visitHistoryDetails.errorPresent=true;
        this.getCategories();
      }
    })
  }

  isVisited(){
    let visitDetails=undefined;
    
    if(this.visitHistoryDetails.visits.length>0)
      visitDetails = this.visitHistoryDetails.visits.find((visit:any)=>localStorage.getItem('userId')===visit.user_id.toString());

    if(visitDetails){
      this.visited=true;
      this.visit.comment=visitDetails.comments;
      this.visit.selectedFeedbacks=visitDetails.feedbackCategory.map((item:any)=>{return {feedbackCd:item.feedbackCategoryId, feedbackMsg:item.feedbackCategoryMsg}});
      if(visitDetails.accomp_wrk_dtl){
        this.visit.selectedWorkers=visitDetails.accomp_wrk_dtl.map((worker:any)=>{
          return {
            ritwikCode:worker.accompWrkId,
            fullName:worker.accompWrkName,
            state:worker.accompWrkState,
            district:worker.accompWrkDistrict,
            workerType:worker.accompWrkType}
        });
      }
      this.memDetails.contact=visitDetails.contact;
      this.memDetails.familyCode=visitDetails.familyCode;
      this.selectedMemKey=visitDetails.phlMemCode;
      this.visitAddress.address=visitDetails.address;
      this.visitAddress.district=visitDetails.visitDistrict;
      this.visitAddress.landmark=visitDetails.landmark;
      this.visitAddress.pincode=visitDetails.visitPincode;
      this.visitAddress.state=visitDetails.visitState;

      this.flow='visit';
      this.allowedSteps=[0,1];this.stepSl=1;
      
    }
    this.getCategories();
  }

  getCategories(){
    this.visitTransmission.fetchCategories({uiState:this.data.memKey.state_name,uiDistrict:this.data.memKey.district_name}).subscribe({
      next:(response)=>{
        if(response.error){
          this.visit.feedbackList=[{feedbackCd:-1,feedbackMsg:response.message}];
        }
        else{
          this.visit.feedbackList=response.data;
        }
        this.loading=false;
      },
      error:(err)=>{
        this.visit.feedbackList=[{feedbackCd:-1,feedbackMsg:'Error:'+err}];
        this.loading=false;
      }
    });
  }

  //choice for final submission
  choose(choice:string){
    if(choice==='visit'){
      this.addOrUpdateVisit();
    }
    else{
      this.updateMember();
    }
  }

  updateMember(){
    this.loading=true;
    this.toasterService.info('Member is being updated...','Info');
    let slNo=this.data.memKey.SL_NO;
    let fcMember=this.fcMembers.find((member)=>{return member.mem_key===this.selectedMemKey});
    let workers=this.visit.selectedWorkers.filter((worker)=>worker&&worker.ritwikCode);
    let memName='';
    let guardName='';
    if(this.memDetails.memMname){
      memName=this.memDetails.memFname+' '+this.memDetails.memMname+' '+this.memDetails.memLname;
    }
    else{
      memName=this.memDetails.memFname+' '+this.memDetails.memLname;
    }
    if(this.memDetails.guardMname){
      guardName=this.memDetails.guardFname+' '+this.memDetails.guardMname+' '+this.memDetails.guardLname;
    }
    else{
      guardName=this.memDetails.guardFname+' '+this.memDetails.guardLname;
    }
    
    let payLoad={
      comments:this.visit.comment,
      contactNumber:this.memDetails.contact,
      email:this.memDetails.email,
      encryptedLastIshtabhrityDate:fcMember.enc_last_transaction_date,
      encryptedMemCode:fcMember.enc_mem_key,
      involvedWorkers:workers.map((worker)=>{return {fullName:worker.fullName,workerType:worker.workerType,ritwikCode:worker.ritwikCode}}),
      lastIshtabhrityDate:fcMember.mem_last_transaction_date,
      memCode:fcMember.mem_key,
      memName:fcMember.mem_name,
      memSurname:fcMember.mem_surname,
      memStatus:this.memDetails.memStatus.value,
      memberFamilyCode:fcMember.mem_family_code,
      permanentAddressLine1:this.permAddress.address,
      permanentDistrict:this.permAddress.district,
      permanentLandmark:this.permAddress.landmark,
      permanentPO:this.permAddress.postOffice,
      permanentPin:this.permAddress.pincode,
      permanentState:this.permAddress.state,
      presentAddressLine1:this.presAddress.address,
      presentDistrict:this.presAddress.district,
      presentLandmark:this.presAddress.landmark,
      presentPO:this.presAddress.postOffice,
      presentPin:this.presAddress.pincode,
      presentState:this.presAddress.state,
      suggestedGuardianName:guardName,
      suggestedMemberName:memName,
      suggestedRitwikCode:this.memDetails.ritwik.ritwikCode,
      suggestedRitwikName:this.memDetails.ritwik.fullName
    }

    if(this.memDetails.memReason.label){
      Object.assign(payLoad,{inactiveReason:this.memDetails.memReason.value});
    }
    // console.log(Number(slNo),payLoad);
    this.updateMemberService.updateMemberDetails(Number(slNo),payLoad).subscribe({
      next:(response)=>{
        if(response.error){
          this.toasterService.error(response.message,'Error');
          this.addOrUpdateVisit();
        }
        else{
          this.toasterService.success(response.message,'Success');
          this.allowedSteps=[0,3];
          this.flow='visit';
          this.addOrUpdateVisit();    
        }
      },
      error:(err)=>{
        this.toasterService.error(err,'Error');
        this.addOrUpdateVisit();
      }
    });
  }

  addOrUpdateVisit(){
    this.loading=true;
    this.toasterService.info('Visit is being added...','Info');
    let fcMember=this.fcMembers.find((mem)=>{return mem.mem_key===this.selectedMemKey});
    let workers=this.visit.selectedWorkers.filter((val)=>val&&val.ritwikCode);
    let feedbacks:{feedbackCd:number,feedbackMsg:string}[]=this.visit.selectedFeedbacks.filter((feedback)=>feedback.feedbackCd!==-1)
    this.locationService.getCurrentPosition().subscribe({
      next:(position:GeolocationPosition)=>{
        let payLoad={
          validPincode:this.data.memKey.pin,
          uiState:this.data.memKey.state_name,
          uiDistrict:this.data.memKey.district_name,
          contact:this.memDetails.contact,
          comments:this.visit.comment,
          latitude:position.coords.latitude,
          longitude:position.coords.longitude,
          feedbackCategory:feedbacks.map((feedback)=>feedback.feedbackCd.toString()),//check if feedbackCd is string
          memKey:this.data.memKey.SL_NO,
        }
        if(this.visited){
          Object.assign(payLoad,{
            userId:localStorage.getItem('userId'),
            pincode:this.data.memKey.pin
          })
        }
        if(this.permAddress.pincode){
          Object.assign(payLoad,{
            visitPincode:this.permAddress.pincode,
            visitDistrict:this.permAddress.district,
            visitState:this.permAddress.state
          });
        }
        else{
          Object.assign(payLoad,{
            visitPincode:'',
            visitDistrict:'',
            visitState:''
          })
        }
        if(fcMember){
          Object.assign(payLoad,{
            familyCode:fcMember.mem_family_code,
            phlMemCode:fcMember.mem_key,
            phlFullName:fcMember.mem_name+' '+fcMember.mem_surname,
            lastIstavrityDate:fcMember.mem_last_transaction_date
          });
        }
          
        // if(this.permAddress.address)
          Object.assign(payLoad,{address:this.permAddress.address});
        // if(this.permAddress.landmark)
          Object.assign(payLoad,{landmark:this.permAddress.landmark});
        if(workers.length>0)
          Object.assign(payLoad,{accomp_wrk_dtl:workers.map((worker)=>worker.ritwikCode)});
        else
          Object.assign(payLoad,{accomp_wrk_dtl:[]});
        
        if(this.visited){

          this.visitTransmission.updateVisitData(payLoad).subscribe({
            next:(response)=>{
              // console.log(response);
              
              if(response.error){
                this.toasterService.error(response.message,'Error');
                this.loading=false;
              }
              else{
                this.toasterService.success(response.message,'Success');
                this.loading=false;
                this.dialogRef.close();
              }
            },
            error:(err)=>{
              this.toasterService.error(err,'Error');
              this.loading=false;
            }
          });
        }
        else{
          // payLoad=Object.assign(payLoad,{contact:this.memDetails.contact});
          this.visitTransmission.addVisitData(payLoad).subscribe({
            next:(response)=>{
              // console.log(response);
              
              if(response.error){
                this.toasterService.error(response.message,'Error');
                this.loading=false;
              }
              else{
                this.toasterService.success(response.message,'Success');
                this.loading=false;
                this.dialogRef.close('refresh table');
              }
            },
            error:(err)=>{
              this.toasterService.error(err,'Error');
              this.loading=false;
            }
          });
        }
      },
      error:(err)=>{
        this.toasterService.error('Please ensure that location is enabled and available.','Location error')
        this.loading=false;
      }
    });
  }

  //capitalizes only the first letter of every part of the name
  optimizeName(name:string){
    if(!name)
      return name;

    name=name.trim();
    let parts=name.split(' ');
    let whole='';
    parts.forEach((part)=>{
      whole=whole+part[0].toUpperCase()+part.substring(1).toLowerCase()+' ';
    });
    return whole;
  }

  //data from comments component
  assignDetails(value:any){
    console.log('memdetails from comments',value);
    
    this.memDetails.contact=value.contact;
    this.memDetails.familyCode=value.familyCode;
  }
  assignAddress(value:any){
    this.permAddress={...value,postOffice:'',POList:['']};
    this.visitAddress=value;
  }

  //checks and allows access to permitted stages in the form
  allowStep(index:number,stepper?:boolean){
    if (this.allowedSteps.includes(index)){
      this.allowedSteps.splice(index+1);
      this.stepSl=index;
    }
    else{ //if(this.stepSl===0&&(index===1||index===3)&&(stepper===false||!stepper)){
      // if(index===1){
      //   this.flow='update';
      // }
      // else{
        this.flow='visit';
      // }
      
      if(this.fcMembers.length>0&&this.selectedMemKey){
        this.memDetails.familyCode=this.fcMembers[0].mem_family_code;
      }
      else{
        if(!this.visited||(this.visited&&this.selectedMemKey===null))
          this.memDetails.familyCode='';
      }
      // this.memDetails.familyCode=(this.fcMembers.length>0&&this.selectedMemKey)?this.fcMembers[0].mem_family_code:this.memDetails.familyCode;
      this.allowedSteps.push(index);
      this.stepSl=index;
    }
    // else if((index - this.stepSl) === 1 && (stepper===false||!stepper)){
    //   console.log('stepper->',stepper);
      
    //   this.allowedSteps.push(index);
    //   this.stepSl=index;
    // }
  }
}
